import _ from 'lodash'
import qs from 'qs'
import { toast } from 'react-toastify'

import api from '../lib/api'

export const LIST_USERS_SUCCESS = 'LIST_USERS_SUCCESS'
export const LIST_USERS_FAILURE = 'LIST_USERS_FAILURE'
export const SET_USER_IS_LOADING_SUCCESS = 'SET_USER_IS_LOADING_SUCCESS'
export const SET_USER_SELECTED_SUCCESS = 'SET_USER_SELECTED_SUCCESS'
export const CLEAR_USER_KEY_SUCCESS = 'CLEAR_USER_KEY_SUCCESS'

const defaultQuery = { limit: process.env.REACT_APP_PAGE_LIMIT, page: 1 }

export const listUsers = (query = defaultQuery, key) => async dispatch => {
  try {
    const { data } = await api.get(`/api/users?${qs.stringify(_.merge({}, defaultQuery, query))}`)
    dispatch({ type: LIST_USERS_SUCCESS, data: { query, list: data, key } })
  } catch (err) {
    toast.error('Failed to retrieve the list of the users.')
    console.log(err.msg)
    dispatch({ type: LIST_USERS_FAILURE, err })
  }
}

export const setUserIsLoading = (isLoading, key) => dispatch => {
  dispatch({ type: SET_USER_IS_LOADING_SUCCESS, data: { isLoading, key } })
}

export const setUserSelected = (selected, key) => dispatch => {
  dispatch({ type: SET_USER_SELECTED_SUCCESS, data: { selected, key } })
}

export const clearUserKey = (key) => dispatch => {
  dispatch({ type: CLEAR_USER_KEY_SUCCESS, data: { key } })
}





// WEBPACK FOOTER //
// ./src/actions/user.js